export default __webpack_public_path__ + "static/media/gallery-10-1.c4bcc249.webp";